(function () {
    var cta = document.getElementById('withdrawal-popup-cta');
    var modal = document.getElementById('withdrawal-popup');
    if (!cta || !modal) return;

    var panel = modal.querySelector('.withdrawal-popup__panel');
    var closeBtn = modal.querySelector('.withdrawal-popup__close');
    var iframe = document.getElementById('wdp-iframe-withdrawal-popup');
    var embedInitialized = false;

    function openModal() {
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
        cta.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        if (!embedInitialized && iframe) {
            embedInitialized = true;
            initConsentmoEmbed();
        }
    }

    function closeModal() {
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        cta.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
    }

    cta.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeModal();
        });
    }

    modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal();
        }
    });

    function initConsentmoEmbed() {
        var f = iframe;
        if (!f) return;

        f.style.overflow = 'hidden';
        f.setAttribute('scrolling', 'no');

        var baseU =
            'https://app.consentmo.com/customers/withdrawalPage?h=fd2751d1f4a8f6d9555e1736d5ed4780d89e35db64317b858ef82ac8ab57e4ce&shop=bare-performance-nutrition.myshopify.com';
        var u = baseU;
        var t = null;

        if (location.hash) {
            var re = /(?:^|[#&?])token=([^&]+)/;
            var mm = location.hash.match(re);
            if (mm) t = decodeURIComponent(mm[1]);
        }

        var wdpLocCfg = { wdpMl: true, bannerMl: false, detection: 'locale', predefined: 'en' };
        var l;

        function wdpUrlLocale() {
            try {
                var sm = location.search.match(/[?&]locale=([^&#]*)/);
                if (sm) return decodeURIComponent(sm[1]).split('-')[0].toLowerCase();
            } catch (e0) { }
            try {
                if (location.hash) {
                    var hm = location.hash.match(/(?:^|[#&?])locale=([^&]+)/);
                    if (hm) return decodeURIComponent(hm[1].replace(/\+/g, ' ')).split('-')[0].toLowerCase();
                }
            } catch (e1) { }
            return '';
        }

        function wdpActiveLoc() {
            try {
                var d = (document.documentElement && document.documentElement.lang) || '';
                d = String(d).split('-')[0].toLowerCase();
                if (d) return d;
            } catch (e) { }
            try {
                var rr = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) || '';
                var rm = String(rr).match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
                if (rm) return rm[1].split('-')[0].toLowerCase();
            } catch (e2) { }
            try {
                if (typeof Shopify !== 'undefined' && Shopify.locale)
                    return String(Shopify.locale).split('-')[0].toLowerCase();
            } catch (e3) { }
            return '';
        }

        var urlL = wdpUrlLocale();
        if (urlL) {
            l = urlL;
        } else if (!wdpLocCfg.wdpMl) {
            l = wdpActiveLoc() || (navigator.language || '').split('-')[0] || 'en';
        } else {
            var det = wdpLocCfg.detection || 'locale';
            var pre = wdpLocCfg.predefined || 'en';
            if (det === 'browser') {
                l = (navigator.language || '').split('-')[0] || pre;
            } else if (det === 'ip') {
                try {
                    var gd = localStorage.getItem('gdprCache');
                    if (gd) {
                        var c = JSON.parse(gd);
                        var cc = (c.countryDetection || '').toLowerCase();
                        var m = { gb: 'en', us: 'en', ca: 'en', au: 'en' };
                        l = m[cc] || cc || pre;
                    } else {
                        l = pre;
                    }
                } catch (e) {
                    l = pre;
                }
            } else if (det === 'url') {
                var um = location.pathname.match(/^\/([a-z]{2}(?:[-_][a-z]{2})?)(?:\/|$)/i);
                l = um ? um[1].toLowerCase() : wdpActiveLoc() || pre;
            } else if (det === 'locale') {
                l = wdpActiveLoc() || pre;
            } else {
                l = pre;
            }
        }

        if (l) u += '&locale=' + encodeURIComponent(l);
        if (t) u += '&token=' + encodeURIComponent(t);
        f.src = u;

        function wdpScrollPanelToTop() {
            if (panel) panel.scrollTop = 0;
        }

        window.addEventListener('message', function (e) {
            if (!e || !e.data || !f) return;

            if (e.data.type === 'wdp-resize' && typeof e.data.height === 'number') {
                f.style.height = Math.max(200, e.data.height) + 'px';
                return;
            }

            if (e.data.type === 'wdp-scroll-actions' && typeof e.data.bottom === 'number') {
                try {
                    var ir = f.getBoundingClientRect();
                    var targetY = ir.top + e.data.bottom;
                    var reserve = 120;
                    var maxVisible = window.innerHeight - reserve;
                    if (targetY > maxVisible) {
                        if (panel) {
                            panel.scrollBy({ top: targetY - maxVisible, left: 0, behavior: 'auto' });
                        } else {
                            window.scrollBy({ top: targetY - maxVisible, left: 0, behavior: 'auto' });
                        }
                    }
                } catch (x) { }
                return;
            }

            if (e.data.type === 'wdp-scroll-top' && f) {
                wdpScrollPanelToTop();
                try {
                    f.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
                } catch (x) {
                    try {
                        f.scrollIntoView(true);
                    } catch (x2) { }
                }
                wdpScrollPanelToTop();
                window.setTimeout(wdpScrollPanelToTop, 0);
                window.setTimeout(wdpScrollPanelToTop, 120);
                window.setTimeout(wdpScrollPanelToTop, 400);
                return;
            }

            if (e.data.type === 'wdp-back') {
                history.replaceState(null, '', location.pathname + location.search);
                f.src = baseU + (l ? '&locale=' + encodeURIComponent(l) : '');
                return;
            }

            if (e.data.type === 'wdp-confirmed') {
                history.replaceState(null, '', location.pathname + location.search);
            }
        });
    }
})();